import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthorityFullData } from '@/core/types/security/authority';
import { DailyBonus } from '../types/util/daily-bonus';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    constructor(private http: HttpClient) {}

    public getMe(): Observable<AuthorityFullData> {
        return this.http.get<AuthorityFullData>(`${environment.dashboardApiURL}/me`);
    }

    public generateAuthorityToken(): Observable<any> {
        return this.http.post<any>(`${environment.dashboardApiURL}/my-authority-tokens`, null);
    }

    public getDailyBonus(): Observable<DailyBonus[]> {
        return this.http.get<DailyBonus[]>(`${environment.dashboardApiURL}/globals/daily-bonus`);
    }

    public updateDailyBonus(dailyBonus?: DailyBonus[]): Observable<DailyBonus[]> {
        return this.http.put<DailyBonus[]>(`${environment.dashboardApiURL}/globals/daily-bonus`, dailyBonus);
    }
}
